/**
 * ElevenLabs TTS configuration constants
 * Shared between frontend and backend
 */
export const ELEVENLABS_CONFIG = {
  MODEL_ID: 'eleven_multilingual_v2',
  OUTPUT_FORMAT: 'pcm_16000' as const,
  AUDIO_CONTENT_TYPE: 'audio/pcm',
} as const;
